import {useState, useEffect} from "react";
import {WikiPage} from "../logic/APITypes";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";

/** A hook for fetching some tagged text from the content of a wiki page */
function useWiki(pagePath: string, tagName: string) {
  const [wikiPage, setWikiPage] = useState<Resolution<WikiPage>>({
    success: false,
    unresolved: true,
  });
  const [tooltip, setTooltip] = useState<string>();

  useEffect(() => {
    API.getWikiPageContent(pagePath).then((resolution) => {
      const content = resolution.payload?.data.pages.singleByPath?.content;
      if (!content) {
        setWikiPage(
          resolution.success
            ? {
                success: false,
                httpCode: 404,
                errorReason: `Page ${pagePath} does not exist.`,
              }
            : resolution,
        );
        return;
      }
      const match = content.match(
        new RegExp(`<!--\\s*${tagName}:start.*${tagName}:end\\s*-->`),
      );

      if (!match) {
        setWikiPage({
          success: false,
          httpCode: 404,
          errorReason: `The tag ${tagName} does not exist on page ${pagePath}.`,
        });
        return;
      }
      setTooltip(
        match[0]
          .replace(new RegExp(`^<!--\\s*${tagName}:start\\s*`), "")
          .replace(/^-->\s*/, "")
          .replace(new RegExp(`\\s*${tagName}:end\\s*-->$`), "")
          .replace(/\s*<!--$/, ""),
      );
      setWikiPage(resolution);
    });
  }, []);

  return {
    wikiContent: {
      ...wikiPage,
      payload: wikiPage.payload?.data.pages.singleByPath?.content,
    },
    tooltip,
  };
}

export default useWiki;
